// To avoid dead code removal
require('../register-builder/register-builder');
import Error from 'next/error';
import { BuilderComponent } from '@builder.io/react';
import { BuilderContent } from '@builder.io/sdk';
import { useRouter } from 'next/router';

type Props = {
  /**
   * Same as BuilderComponent.props.content
   */
  content?: BuilderContent;
};

/**
 * Drop this on a page where BuilderComponent is depended on.
 *  - [page].tsx
 *  - pages/404.tsx for editing unpublished drafts
 *  - editing-url.tsx for Builder "editing url"
 */
export function PageBuilderComponent(props: Props) {
  const { asPath } = useRouter();

  // Don't allow users to visit URLs that serve rebranded content directly
  if (asPath.endsWith('-v5-rebranded')) return <Error statusCode={404} />;

  return <BuilderComponent content={props.content} model="page" />;
}
